import { Box, Skeleton, useMediaQuery } from '@mui/material'
import { useTheme } from '@thriveglobal/thrive-web-leafkit'
import { CardListSkeleton, FeaturedCardSkeleton } from './'

export type OverviewSkeletonProps = {
    id?: string
    isFeaturedCard?: boolean
    tallButton?: boolean
    isSkeletonButton?: boolean
    sx?: Record<string, any>
}

export default function OverviewSkeleton({
    id,
    isFeaturedCard,
    tallButton,
    isSkeletonButton,
    sx
}: OverviewSkeletonProps) {
    const theme = useTheme()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'))

    const testId = id || 'overview-skeleton'

    const getSkeletonCols = () => {
        switch (true) {
            case isSkeletonButton && !isSmallScreen && !isMediumScreen:
                return 7
            case isSkeletonButton && (isSmallScreen || isMediumScreen):
                return 3
            case !isSkeletonButton && isSmallScreen:
                return 1
            case isMediumScreen:
                return 2
            default:
                return 3
        }
    }

    return (
        <Box data-testid={testId} sx={sx}>
            <Skeleton variant="text" width={300} height={40} />
            {isFeaturedCard ? (
                <FeaturedCardSkeleton />
            ) : (
                <CardListSkeleton
                    cols={getSkeletonCols()}
                    rows={1}
                    isSkeletonButton={isSkeletonButton}
                    tallButton={tallButton}
                />
            )}
        </Box>
    )
}
